import API_ROUTES from "app/constants/routes/api";
import Api from '../../../../api/Api'

export const getSingleUserData = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.GET_PROFILE_DETAILS, payload);
    return response;
};

export const getFillCylinderList = async ({ payload, pageNo }) => {
    const response = await Api.post(API_ROUTES.GET_USER_TOOLS(pageNo), payload);
    return response;
};

export const getFillCylinderRentalJob = async ({ payload, pageNo }) => {
    const response = await Api.post(API_ROUTES.GET_NEW_CYLINDER(pageNo), payload);
    return response;
};

export const fillJobCylinder = async ({ payload, pageNo }) => {
    const response = await Api.post(API_ROUTES.GET_NEW_CYLINDER(pageNo), payload);
    return response;
};

export const jobIdList = async ({ status, cylinderId, limit = 5, cursor }) => {
    const response = await Api.get(API_ROUTES.GET_JOB_ID_LIST({ status, cylinderId, limit, cursor }));
    return response;
};

export const getUserList = async ({ payload, pageNo }) => {
    const response = await Api.post(API_ROUTES.GET_ALL_DEALER(pageNo), payload);
    return response;
};

export const getSearchUserList = async ({ payload, pageNo }) => {
    const response = await Api.post(API_ROUTES.SEARCH_USER_API(pageNo), payload);
    return response;
};

export const getSubCategoryApi = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.GET_CATEGORIES, payload);
    return response;
};

export const getInChargeListApi = async ({ payload }) => {
    const response = await Api.get(API_ROUTES.GET_INCHARGE_LIST({ payload }));
    return response;
};
export const getInChargeListJobViewApi = async ({ payload }) => {
    const response = await Api.get(API_ROUTES.GET_INCHARGE_LIST_JOB_VIEW({ payload }));
    return response;
};

export const deleteInChargeApi = async ({ payload }) => {
    const response = await Api.delete(API_ROUTES.DELETE_INCHARGE, { data: payload });
    return response;
};

export const addInChargeApi = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.ADD_EDIT_INCHARGE, payload);
    return response;
};

export const editInChargeApi = async ({ payload }) => {
    const response = await Api.patch(API_ROUTES.ADD_EDIT_INCHARGE, payload);
    return response;
};

export const getTemplateApi = async ({ templateType }) => {
    const response = await Api.get(API_ROUTES.GET_TEMPLATE({ templateType }));
    return response;
};

export const getFileUploadListApi = async ({ payload }) => {
    const response = await Api.get(API_ROUTES.GET_FILES_LIST({ payload }));
    return response;
};
export const getSingleFileListApi = async ({ payload }) => {
    const response = await Api.get(API_ROUTES.GET_SINGLE_FILE_LIST({ payload }));
    return response;
};
export const getSingleStateWiseFileListApi = async ({ payload }) => {
    const response = await Api.get(API_ROUTES.GET_SINGLE_STATE_WISE_FILE_LIST({ payload }));
    return response;
};
export const uploadFileApi = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.UPLOAD_FILE_LIST, payload);
    return response;
};

export const stateCertificateUploadFileApi = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.STATE_CERTIFICATE_UPLOAD_FILE_LIST, payload);
    return response;
};

export const deSelectInChargeApi = async ({ payload }) => {
    const response = await Api.post(API_ROUTES.DESELECT_INCHARGE, payload);
    return response;
};

export const searchCylinder = async ({ payload, pageNo }) => {
    const response = await Api.post(API_ROUTES.GET_CYLINDER_BY_ID(pageNo), payload);
    return response?.data;
};

export const passwordChangeApi = async ({ payload }) => {
    const response = await Api.patch(API_ROUTES.PASSWORD_CHANGE, payload);
    return response;
};

export const changeParentUserApi = async ({ payload }) => {
    const response = await Api.patch(API_ROUTES.CHANGE_PARENT_USER, payload);
    return response;
};

export const deleteCertificateInfoApi = async ({ id }) => {
    const response = await Api.delete(API_ROUTES.DELETE_CERTIFICATE_INFO(id));
    return response;
};

